// Should stay in sync with directChannelOptions.mjs

import { DIRECT_CHANNEL_TYPE } from './directChannelType';

export const DIRECT_CHANNEL_OPTIONS = {
  [DIRECT_CHANNEL_TYPE.NA]: 'N/A',
  [DIRECT_CHANNEL_TYPE.DC_ATM]: 'DC ATM',
  [DIRECT_CHANNEL_TYPE.DC_ATL]: 'DC ATL'
};
